export default "__VITE_ASSET__BSti1BwL__"